import { set as setConfig } from './config';

export function set(defaults?: { [key: string]: any }, applicationUid: string | null = null) {
    setConfig('defaults', defaults, applicationUid);
}
